import { NumberLiteralType } from "typescript";
import { CommonFunctions } from "../static/common-functions";
import { BaseBus } from "./BaseBus";

export class EquipmentSalesBuyoutsBus extends BaseBus{
    constructor(busObj: EquipmentSalesBuyoutsBus){
        super(busObj);
    }
    CID(): any {
        return this.bidEquipBuyOutID;
    }
    setId(id: any) {
        this.bidEquipBuyOutID = id;
    }
    setParentId(id: any) {
        this.bidSheetDetailId = id;
    }
    initialize(data: EquipmentSalesBuyoutsBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: EquipmentSalesBuyoutsBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    } 
bidEquipBuyOutID:string;
description:string;
qty:number;
unitCost:number;
margin :number;
unitSell:number;
sellPrice:number;
bidSheetDetailId:string;
insertDt: Date;
updateDt: Date;
updateUserId: string;
insertUserId: string;
sortOrder  : number;
public dragging: boolean
}